/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DragOutlined } from '@ant-design/icons';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { DOMAIN } from '../../../../SellingRateCalendarPage/state/constants';
import { useInjectSaga } from '../../../../../utils/redux/injectSaga';
import { useInjectReducer } from '../../../../../utils/redux/injectReducer';
import reducer from '../../../../SellingRateCalendarPage/state/reducer';
import saga from '../../../../SellingRateCalendarPage/state/saga';
import { Header, HeaderContainer, DragContainer, ScrollableBodyTall } from '../../../../DashboardPage/GridComponents';
import messages from './messages';
import { statsService } from '../../../../../utils/api';
import { Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Line, ComposedChart } from 'recharts';
import { isEmpty, orderBy } from 'lodash';
import Table from 'components/Table';
import dayjs from 'utils/dayjs';
import { toCurrency } from 'legacy/main/helpers/numberHelper';
import { Skeleton } from 'antd';
import { makeColumnFilteringProps } from '../../shared';
import ReactCardFlip from 'react-card-flip';

const { Column } = Table;

const LySpit = ({ isDraggable, token, propertyUuids, individualPropertyID }) => {
    useInjectReducer({ key: DOMAIN, reducer });
    useInjectSaga({ key: DOMAIN, saga });
    const intl = useIntl();
    const [fetching, setFetching] = useState(false);
    const [fetched, setFetched] = useState(false);
    const [data, setData] = useState([]);
    const [isFlipped, setFlipped] = useState(false);
    const [graphData, setGraphData] = useState();
    const [selectedProperty, setSelectedProperty] = useState('');
    const [selectedPropertyCurrency, setSelectedPropertyCurrency] = useState('GBP');

    const dragContainer = isDraggable && (
        <DragContainer className="draggable-item">
            <DragOutlined />
        </DragContainer>
    );

    const loadData = async () => {
        setFetching(true);
        setFetched(false);
        let lyspitData;
        if (individualPropertyID) {
            const response = await statsService({
                token,
            }).getAccountManagementLySpitAllProperties({
                propertyID: individualPropertyID,
                start: dayjs().startOf('month').format('YYYY-MM-DD'),
                end: dayjs().endOf('month').format('YYYY-MM-DD'),
            });
            lyspitData = response?.data || [];
        } else {
            const response = await statsService({
                token,
            }).getAccountManagementLySpitAllProperties({
                start: dayjs().startOf('month').format('YYYY-MM-DD'),
                end: dayjs().endOf('month').format('YYYY-MM-DD'),
            });
            lyspitData = response?.data || [];
        }
        if (!isEmpty(propertyUuids)) {
            lyspitData = lyspitData.filter(({ uuid }) => propertyUuids.includes(uuid));
        }
        setData(
            lyspitData
                .filter((d) => d.current < d.lyspit)
                .map((d) => ({
                    ...d,
                    diff: (d.current - d.lyspit) / d.lyspit,
                })),
        );
        setFetching(false);
        setFetched(true);
    };

    useEffect(() => {
        loadData();
    }, [propertyUuids]);

    const handleFlip = async (record) => {
        if (!isFlipped) {
            setSelectedProperty(record.name);
            setSelectedPropertyCurrency(record.currency);
            setFetching(true);
            setFetched(false);
            const response = await statsService({
                token,
            }).getAccountManagementLySpitByProperty({
                start: dayjs().startOf('month').format('YYYY-MM-DD'),
                end: dayjs().add(1, 'y').endOf('month').format('YYYY-MM-DD'),
                propertyID: record.id,
            });
            const monthlyData = response.data.map((d) => ({
                stayDate: d.stayDate,
                stayDateFormatted: dayjs(d.stayDate).format('MMM-YY'),
                current: d.current / 100,
                lyspit: d.lyspit / 100,
            }));
            setGraphData(orderBy(monthlyData, [(item) => dayjs(item.stayDate).format('YYYY-MM')], ['asc']));
            setFetching(false);
            setFetched(true);
        }

        setFlipped(!isFlipped);
    };

    return (
        <>
            <HeaderContainer>
                <Header>{intl.formatMessage(messages.title)}</Header>
                {dragContainer}
            </HeaderContainer>
            <ScrollableBodyTall>
                {fetching && (
                    <>
                        <Skeleton active />
                        <Skeleton active />
                        <Skeleton active />
                    </>
                )}
                {!fetching && fetched && (
                    <>
                        <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
                            <div>
                                <div
                                    style={{
                                        width: '100%',
                                        padding: '7px',
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    <FormattedMessage {...messages.description} />
                                </div>
                                <Table
                                    dataSource={data}
                                    pagination={{
                                        pageSize: 31,
                                        hideOnSinglePage: true,
                                    }}
                                    rowKey="name"
                                    tableLayout="auto"
                                    size="small"
                                    scroll={{ y: 390 }}
                                    onRow={(record) => ({
                                        onClick: () => {
                                            handleFlip(record);
                                        },
                                    })}
                                    style={{ height: '50%' }}
                                >
                                    <Column
                                        width="40%"
                                        dataIndex="name"
                                        title={<FormattedMessage {...messages.nameColumnTitle} />}
                                        sorter={(a, b) => a.name.localeCompare(b.name)}
                                        {...makeColumnFilteringProps(data, 'name')}
                                    />
                                    <Column
                                        width="20%"
                                        align="center"
                                        dataIndex="current"
                                        render={(value, record) => toCurrency(value / 100, record.currency, 0)}
                                        title={<FormattedMessage {...messages.currentColumnTitle} />}
                                        sorter={(a, b) => a.current - b.current}
                                    />
                                    <Column
                                        width="20%"
                                        align="center"
                                        dataIndex="lyspit"
                                        render={(value, record) => toCurrency(value / 100, record.currency, 0)}
                                        title={<FormattedMessage {...messages.lyspitColumnTitle} />}
                                        sorter={(a, b) => a.lyspit - b.lyspit}
                                    />
                                    <Column
                                        width="30%"
                                        align="center"
                                        dataIndex="diff"
                                        title={<FormattedMessage {...messages.diffColumnTitle} />}
                                        render={(value) => (
                                            <FormattedNumber
                                                value={value}
                                                minimumFractionDigits={2}
                                                maximumFractionDigits={2}
                                                style="percent"
                                            />
                                        )}
                                        sorter={(a, b) => a.diff - b.diff}
                                        defaultSortOrder="ascend"
                                    />
                                </Table>
                            </div>
                            <div onClick={handleFlip}>
                                <div
                                    style={{
                                        width: '100%',
                                        textAlign: 'center',
                                        fontSize: '1.1em',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {selectedProperty}
                                </div>
                                <ResponsiveContainer width="100%" height={500} className="card-content">
                                    <ComposedChart
                                        data={graphData}
                                        margin={{
                                            top: 20,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                        }}
                                        onClick={handleFlip}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="stayDateFormatted" />
                                        <YAxis
                                            tickFormatter={(value) => toCurrency(value, selectedPropertyCurrency, 0)}
                                        />
                                        <Tooltip
                                            formatter={(value) => toCurrency(value, selectedPropertyCurrency, 0)}
                                        />
                                        <Legend />
                                        <Bar
                                            dataKey="current"
                                            stackId="a"
                                            fill="#82ca9d"
                                            name={intl.formatMessage(messages.graphCurrent)}
                                        />
                                        <Line
                                            dataKey="lyspit"
                                            fill="#e45567"
                                            name={intl.formatMessage(messages.graphLySpit)}
                                        />
                                    </ComposedChart>
                                </ResponsiveContainer>
                            </div>
                        </ReactCardFlip>
                    </>
                )}
            </ScrollableBodyTall>
        </>
    );
};

LySpit.propTypes = {
    token: PropTypes.string.isRequired,
    propertyUuids: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default LySpit;
